import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Stamp } from "../components-atoms";
import { getOrderDate } from "../utils";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { IUPCImportItemProps } from "../redux/actions/upc";

interface IProps {
  data: IUPCImportItemProps;
}

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 24,
    marginBottom: "24px",
    padding: "24px",
    boxSizing: "border-box",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 200ms ease",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      alignItems: " flex-start",
      border: "unset",
    },
    ...textButtonHoverAndActive
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    "& > .MuiTypography-body2": {
      marginTop: 4,
    },
  },
  secondLine: {
    paddingTop: 4
  }
}));

const renderStatus = (status: string) => {
  switch (status) {
    case "Pending":
      return <Stamp type="warning" text="Pending" />;
    case "In Progress":
      return <Stamp type="warning" text="In Progress" />;
    case "Completed":
      return <Stamp type="success" text="Completed" />;
    case "Failed":
      return <Stamp type="fail" text="Failed" />;
    default:
      return null;
  }
}

export function UPCImportItem({
  data,
}: IProps) {
  const classes = useStyles();
  const createDate = getOrderDate(data?.Created?.toString());

  return (
    <Container
      data-testid="delivery-order-item"
      data-order="delivery-order-item"
      className={classes.root}
    >
      <Grid container>
        <Grid item xs className={classes.leftContainer}>
          <Box display="flex" alignItems="center">
            <Typography variant="h6" component="span" color="textPrimary">
              {createDate}
            </Typography>
            {renderStatus(data?.Status)}
          </Box>

          <Typography variant="body2" component="span" color="textSecondary" className={classes.secondLine}>
            Requested by: {data.Creator} {data.Status === 'Completed' && `· ${data?.TotalProducts} products`}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

export default UPCImportItem;
